import styled from "styled-components";
import { colors, device } from "../../../utils";
import {lighten} from 'polished'

const Wrapper
	= styled.button`
		flex: 1;

			&.link-item {
				font-size: 105%;
				font-weight: 600;
				font-family: inherit;
				color: white;
				transition: .2s all;
				padding: calc(6px + .6vw) calc(10px + 1vw);
				background-color: transparent;

				white-space: nowrap;
				user-select: none;
				text-decoration: none;
				border-width: 0 0 2px 0;
				border-color: white;
				transition: .2s all;

				&:not(.selected) {
					cursor: pointer;

					&:hover,
					&:focus,
					&:active {
						border-color: ${lighten(.3, colors.primary)};
						color: ${lighten(.3, colors.primary)};
					}
				}

				&.selected {
					color: ${colors.primary};
					border-color: ${colors.primary};
				}
			}

			@media ${device.mobileUp} {
				&:not(:first-child) {
					margin-left: calc(3px + .2vw);
				}
				width: calc(100px + 7vw);
			}
			@media ${device.mobileDown} {
				&:not(:first-child) {
					margin-left: calc(8px + .8vw);
				}
				width: calc(120px + 7vw);
			}
	`

export default Wrapper
